import { render, staticRenderFns } from "./MembersListModal.vue?vue&type=template&id=680f8d1a&scoped=true"
import script from "./MembersListModal.vue?vue&type=script&lang=js"
export * from "./MembersListModal.vue?vue&type=script&lang=js"
import style0 from "./MembersListModal.vue?vue&type=style&index=0&id=680f8d1a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f8d1a",
  null
  
)

export default component.exports